<template>
  <div class="create-group">
    <a-modal
      :visible="visible"
      :title="title"
      :width="750"
      centered
      wrap-class-name="create-group-modal"
      :mask-closable="false"
      :ok-text="okText"
      :destroy-on-close="true"
      :confirm-loading="confirmLoading"
      :closable="false"
      :z-index="100"
      @cancel="handleCancel"
      @ok="handleSubmit"
    >
      <template slot="title">
        {{ this.isEdit ? '编辑小组' : '新建小组' }}
        <span v-if="this.isEdit"><a-divider type="vertical" />小组ID: {{ groupInfo.id }}</span>
      </template>
      <div class="modal-body">
        <a-form-model
          ref="ruleForm"
          :model="form"
          :rules="rules"
          :label-col="labelCol"
          :wrapper-col="wrapperCol"
          :colon="false"
          label-align="right"
        >
          <a-form-model-item
            ref="name"
            label="小组名称"
            prop="groupName"
            allow-clear
          >
            <a-input
              v-model="form.groupName"
              :max-length="30"
            />
          </a-form-model-item>
          <a-form-model-item v-if="courseName" label="学习机课程">
            <span class="course-name">{{ courseInfo.itvCourseName }}</span>
          </a-form-model-item>
          <a-form-model-item v-if="showCourse" label="学习机课程" prop="classTypeId">
            <CourseSearch
              ref="CourseSearch"
              :disabled="isDisabled"
              :value="form.classTypeId"
              @select="onSelectCourse"
              @clearClassTypeId="clearClassTypeId"
              @change="onCourseChange"
              @valChange="courseInfoChange"
            />
          </a-form-model-item>
          <a-form-model-item v-if="!userInfo?.gddHide && (courseInfo && courseInfo.allowCiCard && !this.isEdit || groupInfo.useCiCard)" label="使用次卡" prop="useCiCard">
            <a-radio-group v-decorator="['radio-group']" :disabled="isDisabled" :value="form.useCiCard" @change="ckChange">
              <a-radio :value="0">
                否
              </a-radio>
              <a-radio :value="1">
                是
              </a-radio>
            </a-radio-group>
          </a-form-model-item>
          <a-form-model-item v-if="(courseInfo && courseInfo.allowCiCard || groupInfo.useCiCard) && form.useCiCard" label="选择讲次" prop="lessonList">
            <a-select
              mode="multiple"
              placeholder="请选择讲次（必须先选择课程）"
              :dropdown-class-name="'multi-checkbox'"
              :value="form.lessonList"
              :remove-icon="customRemoveIcon"
              @change="selectLessonChange"
              @keydown.native="handleDeleteKey"
            >
              <div slot="dropdownRender" slot-scope="menu">
                <div style="max-height: 200px; overflow: auto;">
                  <div
                    v-if="lessonList.length"
                    style="padding: 4px 16px; cursor: pointer;"
                    @mousedown="e => e.preventDefault()"
                  >
                    <a-checkbox :disabled="isEdit" :indeterminate="indeterminate" :checked="checkAll" @change="onCheckLessonAll">
                      全选
                    </a-checkbox>
                  </div>
                  <div
                    style="padding: 4px 16px; cursor: pointer;"
                    v-for="(item, index) in lessonList"
                    :key="item.id"
                    @mousedown="e => e.preventDefault()"
                  >
                    <a-checkbox :disabled="item.checkStatus == 1" :checked="form.lessonList && form.lessonList.includes(item.id)" @change="lessonChange(item.id)" /><span @click.stop="lessonChange(item.id, item.checkStatus)">第{{ index + 1 }}讲-{{ item.name }}</span>
                  </div>
                </div>
                <v-nodes :style="{ display: 'none' }" :vnodes="menu" />
              </div>
              <a-select-option v-for="(item, index) in lessonList" :key="item.id">
                第{{ index + 1 }}讲-{{ item.name }}
              </a-select-option>
            </a-select>
          </a-form-model-item>
          <a-form-model-item label="助学师" prop="userId">
            <a-auto-complete
              v-model="form.userId"
              placeholder="请选择助学师"
              option-label-prop="value"
              allow-clear
              @search="onTeacherSearch"
              @select="onSelectTeacher"
            >
              <template slot="dataSource">
                <a-select-option
                  v-for="(item, index) in teacherList"
                  :key="index"
                  :value="item.nameAndTel"
                  :data-uid="item.userId"
                >
                  {{ item.nameAndTel }}
                </a-select-option>
              </template>
            </a-auto-complete>
          </a-form-model-item>
          <a-form-model-item ref="name" label="学年学期">
            <a-select
              v-model="yearAndSemester"
              placeholder="请选择学年学期"
              allow-clear
            >
              <div class="custom-dropdown" slot="dropdownRender" @mousedown="e => e.preventDefault()">
                <div class="left">
                  <div
                    v-for="(item, index) in baseData.year"
                    :key="index"
                    :class="['item', {'selected': item === form.year}]"
                    @click="() => handleYearClick(item)"
                  >
                    {{ item }}
                  </div>
                </div>
                <div class="right">
                  <div
                    v-for="(item, index) in baseData.semester"
                    :key="index"
                    :class="['item', {'selected': item === form.semester}]"
                    @click="() => handleSemesterClick(item)"
                  >
                    {{ item }}
                  </div>
                </div>
              </div>
            </a-select>
          </a-form-model-item>
          <a-form-model-item ref="name" label="期次" prop="period">
            <a-select v-model="form.period" placeholder="请选择期次" allow-clear>
              <a-select-option :value="item.id" v-for="(item,index) in baseData.period" :key="index">
                {{ item.name }}
              </a-select-option>
            </a-select>
          </a-form-model-item>
          <a-form-model-item ref="name" label="上课周期" prop="classCycle">
            <a-checkbox-group v-model="form.classCycle">
              <a-checkbox v-for="(item,index) in baseData.classCycle" :key="index" :value="item.id">
                {{ item.name }}
              </a-checkbox>
            </a-checkbox-group>
          </a-form-model-item>
          <a-form-model-item ref="name" label="时段" prop="timeInterval">
            <a-checkbox-group v-model="form.timeInterval">
              <a-checkbox v-for="(item,index) in baseData.timeInterval" :key="index" :value="item.id">
                {{ item.name }}
              </a-checkbox>
            </a-checkbox-group>
          </a-form-model-item>
          <div class="select-time">
            <a-form-model-item ref="name" label="日期" :wrapper-col="{span: 16}" prop="subjectId">
              <a-range-picker v-model="form.time" :placeholder="['开课日期','结课日期']" />
            </a-form-model-item>
          </div>
          <a-form-model-item ref="name" label="小组成员" prop="groupMember">
            <div class="group-members-box">
              <div class="member-list">
                <div class="member-item member-add" @click="handleAddMember">
                  <i class="iconfont icon-add" />
                </div>
                <div class="member-item" :class="{'conflict': isConflict(item), 'delet': isDelet(item)}" v-for="(item, index) in selectedRows" :key="index">
                  <span class="member-item-name" :title=" item.studentName">{{ item.studentName }}</span>
                  <i class="iconfont icon-close" @click="handleDelStudent(index, item.userId)" />
                </div>
              </div>
              <div class="member-bottom">
                <span class="member-num">已选{{ selectedRows.length }}/100人</span>
                <template v-if="selectedRows.length > 0">
                  <a-tooltip>
                    <template slot="title">
                      清空组员
                    </template>
                    <span class="member-clear" @click="handleClearStudent"><i class="iconfont icon-delete" /></span>
                  </a-tooltip>
                </template>
                <template v-else>
                  <span class="member-clear disabled"><i class="iconfont icon-delete" /></span>
                </template>
              </div>
              <div class="conflict-info">
                <!--
                <p v-if="conflictStudentList.length">
                  {{ `同课程下，有${conflictStudentList.length}位学员已存在在该课程的其他小组中${isEdit ? '，系统将自动解除此小组与学员的关系' : ''}` }}
                </p>
                -->
                <p v-if="conflictStudentList.length">
                  *组内有学员已存在同课程的其他组中，保存后该学生将从原组移至您的组内，请谨慎操作
                </p>
                <p class="delet" v-if="deletedStudentList.length">
                  标红学员已存在同课程下其他小组内，请手动删除后再保存
                </p>
              </div>
            </div>
          </a-form-model-item>
          <a-form-model-item v-gdd-hide ref="name" label="添加新学员">
            <a-button type="primary" icon="plus" @click="handleAddStudentClick">
              添加
            </a-button>
          </a-form-model-item>
        </a-form-model>
      </div>
      <template slot="footer">
        <div class="footer-wrap">
          <div class="card-tip">
            <!-- TODO: 待修改 -->
            <CardTypeNumTip v-gdd-hide :course-info="courseInfo" />
          </div>
          <div>
            <a-button key="back" @click="handleCancel">
              取消
            </a-button>
            <a-button key="submit" type="primary" :loading="confirmLoading" @click="handleSubmit">
              保存
            </a-button>
          </div>
        </div>
      </template>
    </a-modal>
    <add-group-member-modal
      v-if="addGroupMemberVisible"
      :visible.sync="addGroupMemberVisible"
      :selected-keys="selectedRowKeys"
      :selected-list="selectedRows"
      :class-type-id="classTypeIdFinal"
      :group-id="groupId"
      @onOk="onOk"
      :course-info="courseInfo"
      :lesson-id-list="form.lessonList"
      :use-ci-card="form.useCiCard"
    />
    <create-student
      :visible.sync="createStudentVisible"
      @addStudentSuccess="handleAddStudentSuccess"
    />
  </div>
</template>

<script>
import AddGroupMemberModal from './AddGroupMemberModal'
import CreateStudent from '@/components/createStudent/index.vue'
import CourseSearch from '../CourseSearch'
import { mapGetters } from 'vuex'
import mixins from '@/utils/mixins'
import Moment from 'moment'
import CardTypeNumTip from './CardTypeNumTip.vue'
import { debounce } from 'lodash'
import service from '@/service/index'
import othersLog from '@/utils/logger/others.js'

export default {
  name: 'CreateGroupModal',
  mixins: [mixins],
  components: {
    AddGroupMemberModal,
    CourseSearch,
    CreateStudent,
    CardTypeNumTip,
    VNodes: {
      functional: true,
      render: (h, ctx) => ctx.props.vnodes
    }
  },
  props: {
    visible: {
      type: Boolean,
      default: true
    },
    // 要编辑的小组信息，创建时不需要传
    groupInfo: {
      type: Object,
      default: () => {}
    },
    // 课程信息
    course: Object,
    // 课程id
    classTypeId: {
      type: Number,
      default: undefined
    },
    // 课程名称
    itvCourseName: {
      type: String,
      default: ''
    },
    // 是否展示课程选项
    showCourse: {
      type: Boolean,
      default: false
    },
    courseName: {
      type: Boolean,
      default: false
    },
    lessonIdList: Array,
    useCiCard: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      labelCol: { span: 4 },
      wrapperCol: { span: 20 },
      form: {
        groupName: '',
        subjectId: '',
        gradeId: '',
        helper: '',
        userId: '',
        studentUserIds: [],
        classCycle: [],
        timeInterval: [],
        year: (new Date()).getFullYear(),
        semester: '',
        beginTime: '',
        endTime: '',
        classTypeId: '',
        period: '',
        time: [],
        useCiCard: 0,
        lessonList: []
      },
      lessonList: [],
      indeterminate: false,
      checkAll: false,
      rules: {
        groupName: [
          { required: true, message: '请输入小组名称', trigger: 'blur' },
          {
            validator: this.handleValidatorName, trigger: 'blur'
          }
        ],
        userId: [
          { required: true, message: '请选择助学师', trigger: 'blur' }
        ],
        classTypeId: [
          {
            required: true,
            message: '请选择学习机课程',
            trigger: 'blur',
            validator: (rule, value, callback) => {
              const getSelectInfo = this.$refs.CourseSearch.getSelectInfo()
              console.log('getSelectInfo', getSelectInfo)
              // eslint-disable-next-line node/no-callback-literal
              if (!getSelectInfo) callback('请选择学习机课程')
              callback()
            }
          }
        ],
        lessonList: [
          {
            required: true,
            message: '请选择讲次',
            trigger: 'blur',
            validator: (rule, value, callback) => {
              // eslint-disable-next-line node/no-callback-literal
              if (this.form.useCiCard && !this.form.lessonList.length) callback('请选择讲次')
              callback()
            }
          }
        ]
      },
      addGroupMemberVisible: false,
      teacherList: [],
      selectedRows: [],
      selectedRowKeys: [],
      confirmLoading: false,
      searchKey: '',
      groupId: -1,
      isEdit: false,
      conflictStudentList: [], // 会自动解绑的学生列表
      deletedStudentList: [], // 必须要删除的学生列表
      createStudentVisible: false,
      courseInfo: {} // 当前选中的课程
    }
  },

  computed: {
    ...mapGetters({
      userInfo: 'userInfo/userInfo'
    }),
    okText() {
      return this.isEdit ? '保存' : '创建'
    },
    isDisabled() {
      return this.isEdit && this.form.useCiCard
    },
    yearAndSemester: {
      get() {
        const { year, semester } = this.form
        return year && semester ? year + semester : undefined
      },
      set(newVal) {
        if (!newVal) {
          this.form.year = ''
          this.form.semester = ''
        }
      }
    },
    classTypeIdFinal() {
      return this.showCourse ? Number(this.form.classTypeId) : (this.classTypeId || '')
    }
  },

  watch: {
    visible: {
      immediate: true,
      handler(val) {
        if (val) {
          // 重置数据
          this.resetData()
          const { groupInfo } = this
          console.log('编辑小组', groupInfo)
          const isEdit = this.isEdit = groupInfo && groupInfo.id
          // 如果展示课程选项获取课程列表 初始化课程下拉框
          if (this.showCourse) {
            this.$nextTick(() => {
              this.$refs.CourseSearch.initCourseList(groupInfo, true)
            })
          }
          // 编辑状态
          if (isEdit) {
            const { id } = this.groupInfo
            this.groupId = id
            // 获取小组内学生列表
            this.getStudentList(id)
            // 恢复编辑内容
            this.recoveryData(this.groupInfo)
          } else {
            this.groupId = -1
            // 设置登陆账号为默认助学师
            this.setDefaultTeacher()
          }
          // 选中的课程信息
          console.log('111course', val, this.course)
          if (this.course) {
            this.courseInfo = { ...this.course, cardType: this.courseInfo.cardType ? this.courseInfo.cardType : this.course.cardType }
            this.courseInfo._cardType = this.courseInfo.cardType
            console.log('this.courseInfo', this.courseInfo)
            // this.courseInfo.cardType = this.form.useCiCard ? 18 : this.courseInfo._cardType
          }
        }
      }
    }
  },
  methods: {
    customRemoveIcon() {
      return (
        <span/>
      )
    },
    handleDeleteKey(e) {
      const selectedList = this.lessonList.filter(l => l.checkStatus == 1)
      if (selectedList.length > 0) {
        const id = selectedList[selectedList.length - 1].id
        if (this.form.lessonList.length < selectedList.length) {
          this.form.lessonList.push(id)
        }
      }
    },
    /**
     * @description 新增学员
     */
    handleAddStudentClick() {
      this.createStudentVisible = true
    },
    /**
     * @description 设置登陆账号为默认的助学师
     */
    setDefaultTeacher(id, name) {
      const { userId, teacherName } = this.userInfo
      this.searchKey = name || teacherName
      this.getTeacherList(id || userId)
    },
    /**
     * @description 获取已选学生列表
     */
    getStudentList(groupId) {
      this.$service.courseAndGroup.getSelectedStudentList({ xkhTeacherCourseId: groupId }).then(res => {
        this.selectedRows = res || []
        this.selectedRowKeys = (res || []).map(item => item.userId)
      })
    },
    /**
     *  @description 编辑时回显内容
     */
    async recoveryData(groupInfo) {
      console.log('recoveryData', groupInfo)
      const { groupName, userId, teacherName, year, semester, classCycle, timeInterval, period, beginTime, endTime, classTypeId } = groupInfo
      console.log('beginTime', beginTime > 0)
      const begin = beginTime && beginTime.indexOf('1970') < 0 ? new Moment(beginTime) : null
      const end = endTime && endTime.indexOf('1970') < 0 ? new Moment(endTime) : null
      // 恢复助学师
      this.setDefaultTeacher(userId, teacherName)
      this.form = {
        ...this.form,
        userId: `${userId}`,
        groupName,
        helper: userId,
        classCycle: this.strToArray(classCycle),
        timeInterval: this.strToArray(timeInterval),
        year,
        semester,
        period,
        beginTime: begin,
        endTime: end,
        classTypeId: `${classTypeId}`,
        time: [begin, end],
        useCiCard: groupInfo.useCiCard,
        lessonList: null
      }
      await this.getLessonId()
      this.form.lessonList = this.lessonList.filter(l => l.checkStatus == 1).map(l => l.id)
    },
    /**
     * @description 字符串转为数组
     */
    strToArray(str) {
      if (!str) return []
      return str.split('').map(item => (item ? Number(item) : item)).filter(item => item)
    },
    /**
     * @description 开始时间范围
     */
    disabledStartDate(startValue) {
      const { endTime } = this.form
      if (!startValue || !endTime) {
        return false
      }
      return startValue.valueOf() > endTime.valueOf()
    },
    /**
     * @description 结束时间范围
     */
    disabledEndDate(endValue) {
      const { beginTime } = this.form
      if (!endValue || !beginTime) {
        return false
      }
      return beginTime.valueOf() >= endValue.valueOf()
    },
    /**
     * @description 重置数据
     */
    resetData() {
      this.form = {
        groupName: '',
        subjectId: '',
        gradeId: '',
        helper: '',
        userId: '',
        studentUserIds: [],
        classCycle: [],
        timeInterval: [],
        year: (new Date()).getFullYear(),
        semester: '',
        beginTime: '',
        time: [],
        endTime: '',
        classTypeId: '',
        sourceType: 1,
        useCiCard: 0,
        lessonList: []
      }
      this.searchKey = ''
      this.handleClearStudent(false)
      this.conflictStudentList = []
      this.deletedStudentList = []
      this.lastCourse = null
    },
    handleClearStudent(showConfirm = true) {
      const thiz = this
      if (!showConfirm) {
        thiz.selectedRowKeys = []
        thiz.selectedRows = []
        return
      }
      this.$confirm({
        title: '是否移除已选全部学员？',
        onOk() {
          thiz.selectedRowKeys = []
          thiz.selectedRows = []
        }
      })
    },
    /**
     * @description 修改年
     */
    handleYearClick(val) {
      this.form.year = val
    },
    /**
     * @description 修改季节
     */
    handleSemesterClick(val) {
      this.form.semester = val
    },
    /**
     * @description 选择助学师
     */
    onSelectTeacher(val, option) {
      const userId = option.data.attrs['data-uid']
      this.form.helper = userId
    },
    /**
     * @description 搜索助学师
     */
    onTeacherSearch: debounce(function(val) {
      this.searchKey = val
      this.getTeacherList()
    }, 500, { leading: false }),
    /**
     * @description 搜索课程
     */
    onCourseSearch: debounce(function(val) {
      this.getCourseList(val)
    }, 500, { leading: false }),
    /**
     * @description 课程列表
     */
    getCourseList(courseName) {
      this.$nextTick(() => {
        this.$refs.CourseSearch.getCourseList(courseName)
      })
    },
    /**
     * @description 修改课程
     */
    onSelectCourse(value) {
      console.log('修改课程', this.isEdit, value, this.lastCourse)
      // 编辑状态切换课程需要校验学员
      if (this.lastCourse === value) return
      this.conflictStudentList = []
      this.deletedStudentList = []
      // if (this.isEdit && value) {
      if (value) {
        const { id } = this.groupInfo
        this.checkGroupStudent(id, value)
      }
      this.lastCourse = value
    },
    /**
     * @description 选择课程
     */
    onCourseChange(val) {
      this.form.classTypeId = val
      if (this.form.useCiCard) {
        this.form.lessonList = []
        this.getLessonId()
      }
    },
    /**
     * @description 非选中且下拉列表不包含id时清除
     */
    clearClassTypeId() {
      this.form.classTypeId = undefined
    },
    /**
     * @description 校验学员是否在该课程其他组内
     */
    checkGroupStudent(groupId, classTypeId) {
      const cId = classTypeId || this.classTypeId
      const userIds = this.selectedRows.map(k => k.userId)
      if (!cId || userIds.length === 0) return
      const params = {
        classTypeId: cId - 0,
        studentUserIds: userIds,
        pageSize: userIds.length
      }
      if (groupId) params.groupId = groupId
      this.$service.courseAndGroup.checkStudentConflict(params).then(res => {
        const uIds = []
        // 获取已存在于其他组的学员
        res.list.forEach(k => k.otherGroup && uIds.push(k.userId))
        this.conflictStudentList = uIds
      })
    },
    /**
     * @description 获取所有老师
     */
    async getTeacherList(userId) {
      try {
        const { list: result } = await this.$service.courseAndGroup.getTeacherList({
          name: this.searchKey
        })
        result.forEach(item => {
          item.nameAndTel = `${item.name}（${item.telephone}）`
        })
        this.teacherList = result
        // 有userID时默认选中
        if (userId) {
          const user = result.filter(item => item.userId === userId)
          if (user && user.length > 0) {
            console.log('user', user[0])
            const { nameAndTel, userId } = user[0] || {}
            this.form.userId = nameAndTel
            this.form.helper = userId
            console.log(this.form)
          }
        }
      } catch (error) {
        console.log(error)
      }
    },
    /**
     * @description 删除已选学员
     */
    handleDelStudent(idx, id) {
      this.selectedRows.splice(idx, 1)
      this.selectedRowKeys = this.selectedRowKeys.filter(item => !(item === id))
    },
    /**
     * @description 选择学员确认
     */
    onOk(selectedRows, selectedRowKeys) {
      this.selectedRows = selectedRows
      this.selectedRowKeys = selectedRowKeys

      const groupId = this.groupInfo && this.groupInfo.id
      this.checkGroupStudent(groupId, this.form.classTypeId - 0)
    },
    /**
     * @description 取消
     */
    handleCancel() {
      this.$emit('update:visible', false)
    },
    /**
     * @description 添加组员
     */
    handleAddMember() {
      this.addGroupMemberVisible = true
    },
    courseInfoChange(courseInfo) {
      // this.courseInfo = courseInfo
      if (courseInfo) {
        this.courseInfo = {
          ...courseInfo,
          _cardType: courseInfo.cardType,
          cardType: this.form.useCiCard ? 18 : courseInfo.cardType
        }
      }
      // courseInfo && (this.courseInfo._cardType = courseInfo.cardType)
      console.log(123, this.courseInfo)
    },
    /**
     * 选中的课程信息
     */
    getCourseInfo() {
      if (this.course) {
        return this.course
      }
      const courseInfo = this.$refs.CourseSearch.getSelectInfo()
      console.log('courseInfo', courseInfo)
      return courseInfo
    },
    beforeSubmit() {
      return new Promise((resolve, reject) => {
        const { selectedRows } = this
        // 在课程与小组新建小组的时候，没有选择课程，课程直接带过来
        const courseInfo = this.getCourseInfo()
        // classStyle	1长线课\2短线课\3公开课
        const { experience, classStyle, cardType } = courseInfo
        // 无权益的学生
        const noRights = selectedRows.filter(item => item.jurisdiction === 0)
        const stus = noRights.map(stu => stu.studentName).join('&nbsp;&nbsp;')
        let content = ''
        if (experience === 0 && classStyle === 1 && [11, 12, 16, 17].includes(cardType)) {
          // 非体验课并且是长线课,且是一类、二类课程
          content = <div>
            <p>确认保存小组信息吗？</p>
            <p v-gdd-hide class="confirm-tip">注：如果您添加了“无权益”或“体验权益”的学生，需管理员审核后才可开始学习。</p>
          </div>
        } else if (experience === 1 && noRights.length) {
          // 当体验课（所有打体验课标签的课）建组，但组内有”无权益“的学生时，需要弹框提示
          content = <div>
              <p>体验课需要管理员为学生分配了体验或全科权益后，学员才能开始学习。待开通学员（共{noRights.length}位）：</p>
              <p class="no-right-stu" domPropsInnerHTML={stus}></p>
            </div>
        } else {
          // 当小组是短线课或公开课时，或者，小组是体验课但是组内学生都符合账号权益。
          content = <p>确认保存小组信息吗？</p>
        }
        if (!content) {
          return resolve(false)
        }
        this.$confirm({
          content: () => content,
          centered: true,
          // 展示不下时，需要加滚动条
          class: 'xkh-teacher-model-overflow',
          onOk() {
            resolve(true)
          },
          cancelText: '取消',
          onCancel() {
            resolve(false)
          }
        })
      })
    },
    async submitRequest() {
      this.form.studentUserIds = this.selectedRowKeys
      // 更新组
      const isNext = await this.beforeSubmit()
      if (!isNext) {
        return
      }
      this.isEdit ? await this.updateGroup() : await this.createGroup()
    },
    /**
     * @description 提交
     */
    handleSubmit() {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          this.confirmLoading = true
          this.submitRequest().finally(() => {
            this.confirmLoading = false
          })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    /**
     * @description 组装参数
     */
    getParams() {
      const { groupName, year, semester, period, classCycle = [], timeInterval = [], studentUserIds = [], helper, classTypeId, time, useCiCard, lessonList } = this.form
      const xkhStudentCourseList = studentUserIds.map(item => ({ userId: item }))
      const sourceType = this.courseInfo?.sourceType

      const [beginTime, endTime] = time
      const param = {
        groupName,
        year: year && semester ? year : '',
        semester: year && semester ? semester : '',
        period,
        classCycle: classCycle.join(','),
        timeInterval: timeInterval.join(','),
        beginTime: beginTime ? beginTime.format('YYYY-MM-DD 00:00:00') : '1970-01-01 00:00:00',
        endTime: endTime ? endTime.format('YYYY-MM-DD 00:00:00') : '1970-01-01 00:00:00',
        userId: helper,
        xkhStudentCourseList,
        classTypeId: this.showCourse ? classTypeId - 0 : this.classTypeId - 0,
        confirmSubmit: true,
        sourceType,
        useCiCard: this.courseInfo?.allowCiCard === false ? 0 : useCiCard,
        lessonList
      }
      console.log('组装参数', param)
      if (this.isEdit) param.id = this.groupInfo.id
      return param
    },
    /**
     * @description 编辑保存
     */
    async updateGroup() {
      const param = this.getParams()
      if (typeof param.period === 'undefined') {
        param.period = -1
      }
      this.deletedStudentList = []
      if (param.useCiCard) {
        param.lessonList = param.lessonList.filter(l => (this.lessonList || []).findIndex(ll => ll.checkStatus == 1 && ll.id === l) < 0)
      }
      try {
        await this.$service.courseAndGroup.updateGroup(param)
        this.$emit('update:visible', false)
        this.$emit('onSuccess')
        if (param.useCiCard) {
          othersLog.useCiCard({
            ...param
          })
        }
      } catch (res) {
        const { body } = res
        if (Array.isArray(body)) {
          this.deletedStudentList = body
        }
      }
    },
    /**
     * @description 新建小组
     */
    async createGroup() {
      const param = this.getParams()
      console.log(123, param)
      this.deletedStudentList = []
      try {
        await this.$service.courseAndGroup.createGroup(param)
        this.$emit('update:visible', false)
        this.$emit('onSuccess', this.form)
        if (param.useCiCard) {
          othersLog.useCiCard({
            ...param
          })
        }
      } catch (res) {
        const { body } = res
        if (Array.isArray(body)) {
          this.deletedStudentList = body
        }
      }
    },
    /**
     * @description 验证小组名称
     */
    handleValidatorName(rule, value, callback) {
      const { length } = value.replace(/[\u0391-\uFFE5]/g, 'aa')
      if (value && length > 30) {
        // eslint-disable-next-line node/no-callback-literal
        callback('已超过字数限制，最多可输入15个字')
      }
      callback()
    },
    /**
    * @description 换课后原来小组的学生与新课小组学生冲突（黄色提醒、可直接提交）
    */
    isConflict(conflictItem) {
      const conflictList = this.conflictStudentList || []
      return conflictList.filter(item => item === conflictItem.userId).length
    },
    /**
    * @description 换课后新加的学生与新课小组学生冲突（红色提醒，需手动删除）
    */
    isDelet(DeletItem) {
      const deletList = this.deletedStudentList || []
      return deletList.filter(item => item === DeletItem.userId).length
    },
    /**
     * @description 增加新学员回调
     */
    handleAddStudentSuccess(info) {
      if (this.selectedRowKeys.length > 99) {
        this.$message.error('最多添加100个学员！')
        return
      }
      const { userId, name } = info
      this.selectedRowKeys = [...this.selectedRowKeys, userId]
      this.selectedRows = [...this.selectedRows, { ...info, studentName: name }]
    },
    ckChange(e) {
      this.form.useCiCard = e.target.value
      if (e.target.value) {
        // 请求列表
        this.getLessonId()
      } else {
        this.courseInfo.cardType = this.courseInfo._cardType
      }
    },
    async getLessonId() {
      if (!this.form.classTypeId && !this.courseInfo.classTypeId) return
      let classTypeId = this.form.classTypeId || this.courseInfo.classTypeId
      try {
        classTypeId = Number(classTypeId)
      } catch (e) {
        return ''
      }
      if (isNaN(classTypeId)) return
      this.courseInfo.cardType = this.form.useCiCard ? 18 : this.courseInfo._cardType
      const res = await service.supervision.getGroupLessons({
        classTypeId,
        xkh_teacher_course_id: this.groupId || -1
      })
      this.lessonList = res
    },
    selectLessonChange(v) {
      this.form.lessonList = v
      this.indeterminate = this.form.lessonList.length > 0 && this.form.lessonList.length < this.lessonList.length
      this.checkAll = this.form.lessonList.length === this.lessonList.length
    },
    lessonChange(id, checkStatus) {
      if (checkStatus === 1) return
      const index = this.form.lessonList.findIndex(l => l === id)
      index > -1 ? this.form.lessonList.splice(index, 1) : this.form.lessonList.push(id)
      this.indeterminate = this.form.lessonList.length > 0 && this.form.lessonList.length < this.lessonList.length
      this.checkAll = this.form.lessonList.length === this.lessonList.length
    },
    onCheckLessonAll(e) {
      this.form.lessonList = e.target.checked ? this.lessonList.map(l => l.id) : []
      Object.assign(this, {
        indeterminate: false,
        checkAll: e.target.checked
      })
    }
  },
  created() {
    // document.addEventListener('keydown', function(event) {
    //   const key = event.key || event.keyCode
    //   // 判断按下的是否是Delete键
    //   if (key === 'Delete' || key === 'Backspace') {
    //     console.log('Delete key pressed')
    //     event.preventDefault()
    //     event.stopPropagation()
    //   }
    // })
  }
}
</script>

<style lang="less" scoped>
.custom-dropdown {
  display: flex;
  .left, .right {
    height: 200px;
    padding: 8px 0;
    flex: 2;
    text-align: center;
    overflow: auto;
    .item {
      padding: 8px 0;
      &:hover{
        background: #F5F7F9;
      }
      &.selected {
        color: #3262FD;
      }
    }
  }
  .right {
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: center;
    border-left: 2px solid #F5F7F9;
  }
}
:deep(.create-group-modal) {
  .ant-modal-body {
    padding-bottom: 0;
  }
  .ant-form-item-label {
    width: 90px;
  }
  .group-members-box {
    position: relative;
    height: 120px;
    border: 1px solid #EBEDF0;
    padding: 8px 0 26px 8px;
    border-radius: 6px;
    margin-bottom: 20px;
    .member-list {
      height: 100%;
      display: flex;
      flex-wrap: wrap;
      overflow: auto;
      .member-item {
        height: 24px;
        width: 91px;
        background: #EBEDF0;
        border-radius: 4px;
        margin-right: 4px;
        margin-bottom: 4px;
        display: flex;
        align-items: center;
        padding: 0 4px;

        &:nth-child(6n) {
          margin-right: 0;
        }

        &.conflict {
          border: 2px solid #FF5C5C;
        }
        &.delet {
          border: 2px solid #FF5C5C;
        }

        .member-item-name {
          width: 58px;
          height: 24px;
          line-height: 24px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          color: #505873;
        }

        .iconfont {
          font-size: 10px;
          color: #98A2B2;
          cursor: pointer;
        }
      }

      .member-add {
        border: 1px dashed #3262FD;
        background: #fff;
        display: flex;
        justify-content: center;
        cursor: pointer;

        &:hover {
          background: #F5F7F9;
        }

        &:active,
        &:focus {
          background: #EBF0FF;
        }

        .iconfont {
          color: #3262FD;
        }
      }
    }

    .member-bottom {
      position: absolute;
      right: 8px;
      bottom: 5px;
      line-height: 20px;
      font-size: 12px;
      display: flex;
      align-items: center;
      color: #70788C;

      .member-clear {
        width: 22px;
        height: 22px;
        border-radius: 4px;
        margin-left: 4px;
        cursor: pointer;
        color:  #505873;
        display: flex;
        align-items: center;
        &:hover:not(.disabled) {
          background: #F5F7F9;
        }

        &.disabled {
          cursor: unset;

          .iconfont {
            color: #C1C6D0;
          }
        }
      }

      .iconfont {
        color: #505873;
        font-size: 14px;
        margin: 4px;
      }
    }

    .conflict-info {
      height: 50px;
      font-size: 12px;
      line-height: 1.8;
      position: absolute;
      bottom: -54px;
      right: 0px;
      color: #FF5C5C;
      .delet {
        color: #FF5C5C;
      }
    }
  }

  .group-member-tips {
    display: flex;
    align-items: center;
    color: #FF8800;
    font-size: 12px;
    line-height: 20px;
    margin-top: 12px;

    .iconfont {
      font-size: 14px;
      margin-right: 4px;
    }
  }
  .select-time {
    display: flex;
  }
}
.footer-wrap {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: -16px 0;
  height: 65px;
}
.card-tip {
  text-align: left;
}
.no-right-stu {
  color: #3262FD
}
.confirm-tip {
  font-size: 12px;
  color: #98A2B2;
  margin-top: 8px;
}
.course-name {
  font-weight: bold;
}
</style>
<style>
.multi-checkbox{
  .ant-select-dropdown-menu{
    display: none;
  }
}
</style>